import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/lib/auth";
import { I18nProvider } from "@/lib/i18n";
import { api } from "@/lib/api";
import { setPointToPesoRate, applyPublicSettings } from "@/lib/currency";
import Layout from "@/components/Layout";
import CookieBanner from "@/components/CookieBanner";
import Home from "@/pages/Home";
import Markets from "@/pages/Markets";
import MarketDetail from "@/pages/MarketDetail";
import Live from "@/pages/Live";
import Wallet from "@/pages/Wallet";
import Rankings from "@/pages/Rankings";
import Profile from "@/pages/Profile";
import MyProfile from "@/pages/MyProfile";
import Levels from "@/pages/Levels";
import Creators, { CreatorsApply, CreatorsStatus } from "@/pages/Creators";
import CreatorDashboard from "@/pages/CreatorDashboard";
import WalletRecargar from "@/pages/WalletRecargar";
import WalletRetirar from "@/pages/WalletRetirar";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import VerifyEmail from "@/pages/VerifyEmail";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Admin from "@/pages/Admin";
import Legal from "@/pages/Legal";

function App() {
    useEffect(() => {
        api.get("/settings/public")
            .then(({ data }) => {
                if (data?.point_to_peso_rate) setPointToPesoRate(data.point_to_peso_rate);
                applyPublicSettings(data);
            })
            .catch(() => { /* default 1:1 */ });
    }, []);

    return (
        <div className="App">
            <I18nProvider>
                <AuthProvider>
                    <BrowserRouter>
                        <Layout>
                            <Routes>
                                <Route path="/" element={<Home />} />
                                <Route path="/mercados" element={<Markets />} />
                                <Route path="/explore" element={<Markets />} />
                                <Route path="/mercado/:id" element={<MarketDetail />} />
                                <Route path="/en-vivo" element={<Live />} />
                                <Route path="/wallet" element={<Wallet />} />
                                <Route path="/wallet/recargar" element={<WalletRecargar />} />
                                <Route path="/wallet/retirar" element={<WalletRetirar />} />
                                <Route path="/rankings" element={<Rankings />} />
                                <Route path="/perfil/:username" element={<Profile />} />
                                <Route path="/mi-perfil" element={<MyProfile />} />
                                <Route path="/niveles" element={<Levels />} />
                                <Route path="/creadores" element={<Creators />} />
                                <Route path="/creadores/aplicar" element={<CreatorsApply />} />
                                <Route path="/creadores/estado" element={<CreatorsStatus />} />
                                <Route path="/creator/dashboard" element={<CreatorDashboard />} />
                                <Route path="/login" element={<Login />} />
                                <Route path="/registro" element={<Register />} />
                                <Route path="/verify-email" element={<VerifyEmail />} />
                                <Route path="/forgot-password" element={<ForgotPassword />} />
                                <Route path="/reset-password" element={<ResetPassword />} />
                                <Route path="/admin" element={<Admin />} />
                                <Route path="/legal/terminos" element={<Legal kind="terms" />} />
                                <Route path="/legal/privacidad" element={<Legal kind="privacy" />} />
                                <Route path="/legal/cookies" element={<Legal kind="cookies" />} />
                                <Route path="/legal/juego-responsable" element={<Legal kind="responsible" />} />
                                <Route path="/legal/antifraude" element={<Legal kind="antifraude" />} />
                                <Route path="/legal/terminos-creadores" element={<Legal kind="creators_terms" />} />
                                <Route path="/legal/ayuda" element={<Legal kind="terms" />} />
                            </Routes>
                        </Layout>
                        <CookieBanner />
                    </BrowserRouter>
                    <Toaster
                        theme="dark"
                        position="top-right"
                        toastOptions={{
                            style: {
                                background: "#1E1F2E",
                                border: "1px solid #262838",
                                color: "#FFFFFF",
                            },
                        }}
                    />
                </AuthProvider>
            </I18nProvider>
        </div>
    );
}

export default App;
